import React, {useContext, useRef, useState} from 'react'
import {ReactComponent as CartIconSvg} from '@shop/icon-fonts/optimized/cart.svg'
import * as SC from './CartButton.styled'
import {WhiteIcon} from '../Icon/Icon.styled'
import AppContext from '../../context/AppContext'
import {AccessibleText, DEVICE_TYPES} from '../../utils'
import MiniCartFlyout from './MiniCartFlyout'

export const CART_BUTTON_TEST_ID = 'ztaHeaderCartButton'
export const ITEMS_COUNT_TEST_ID = 'ztaHeaderItemsCount'

const CartButton = () => {
  const {
    device,
    translations,
    cart,
    isBurgerNavOpen,
    setBurgerNavOpen,
    isSearchFlyoutOpen,
    setSearchFlyoutOpen
  } = useContext(AppContext)
  const cartCount = cart ? cart.summary.articleCount : 0
  const text = translations.get('shop.header.cart.button.label')
  const accessibleText = <AccessibleText>{text}</AccessibleText>
  const showText = device === DEVICE_TYPES.LAPTOP || device === DEVICE_TYPES.DESKTOP
  const miniCartFlyoutRef = useRef({})
  const cartCountElement = (
    <SC.CartButtonCount data-zta={ITEMS_COUNT_TEST_ID}>{cartCount}</SC.CartButtonCount>
  )

  const [showFlyout, setShowFlyout] = useState(false)

  const onClickOutsideAccountFlyout = (event) => {
    if (miniCartFlyoutRef.current && !miniCartFlyoutRef.current.contains(event.target)) {
      setShowFlyout(false)
      document.removeEventListener('click', onClickOutsideAccountFlyout)
    }
  }

  const toggleFlyout = () => {
    if (isBurgerNavOpen) {
      setBurgerNavOpen(false)
    }
    if (isSearchFlyoutOpen) {
      setSearchFlyoutOpen(false)
    }
    if (!showFlyout) {
      document.addEventListener('click', onClickOutsideAccountFlyout)
    }
    setShowFlyout(!showFlyout)
  }

  const CONTENT = <>
    <WhiteIcon>
      <CartIconSvg aria-hidden aria-labelledby="cartButton" data-zta="cartIconSvg" />
    </WhiteIcon>
    {showText ? text : accessibleText}
    {cartCount > 0 && cartCountElement}
  </>

  if (device === DEVICE_TYPES.SMARTPHONE || device === DEVICE_TYPES.PHABLET) {
    return <>
      <SC.CartButton
        aria-haspopup
        aria-expanded={showFlyout}
        aria-label={text}
        onClick={toggleFlyout}
        data-zta={CART_BUTTON_TEST_ID}
        id="cartButton"
      >
        {CONTENT}
      </SC.CartButton>
      <div ref={miniCartFlyoutRef}>
        <MiniCartFlyout showFlyout={showFlyout} />
      </div>
    </>
  }

  return (
    <SC.CartLink
      role="button"
      href="/checkout/overview"
      data-zta={CART_BUTTON_TEST_ID}
      aria-label={translations.get('shop.header.cart.button.label')}
    >
      {CONTENT}
    </SC.CartLink>
  )
}

export default CartButton
